export default {
  tag: "Real Stories, Real Results",
  title1: "Trusted by Food Truck Operators",
  title2: "Across Orange County",
  subtitle:
    "Over 200 food trucks launched and counting. Here's what our clients have to say about working with My Food Truck Agency.",
  items: [
    {
      name: "Maria Reyes",
      role: "Owner, Taco Fuego OC",
      text: "I had no idea where to start with permits. My Food Truck Agency walked me through every single step — from the MFF application to finding my commissary. We opened in just 10 weeks!",
      highlight: "Opened in 10 weeks",
    },
    {
      name: "Derek Johnson",
      role: "Founder, Seoul on Wheels",
      text: "The permit process in Anaheim was a nightmare until I called these guys. They knew exactly which forms to file, which fees to pay, and even helped us fight a denied application successfully.",
      highlight: "Reversed a permit denial",
    },
    {
      name: "Sandra & Luis Morales",
      role: "Co-owners, Birria Bliss",
      text: "From the brand consultation to finding our first private events, OCFTA delivered on everything. Our business has grown from 1 truck to 3 in just two years. Incredibly grateful.",
      highlight: "Scaled to 3 trucks",
    },
    {
      name: "James Okafor",
      role: "Owner, Naija Bites",
      text: "As someone new to California, I had zero knowledge of the local regulations. OCFTA gave me a clear roadmap and was always responsive to my questions. Best investment I made for my business.",
      highlight: "New to California",
    },
    {
      name: "Ashley Kim",
      role: "Chef-Owner, Umami Pop",
      text: "The brand development package was worth every penny. They helped us design a look that stands out at every market. We get compliments on our truck's design constantly from customers.",
      highlight: "Standout brand identity",
    },
    {
      name: "Carlos Vega",
      role: "Owner, Tacos El Bueno",
      text: "I tried to navigate the OC health code on my own and failed two inspections. After one call with OCFTA, they helped me fix everything and I passed my next inspection with flying colors.",
      highlight: "Passed inspection first try",
    },
  ],
  ctaText: "Ready to write your own success story?",
  ctaButton: "Start Your Journey Today",
};